import findingpiLogo from '../assets/img/brand/findingpi.png';
import w3villaLogo from '../assets/img/brand/w3villa.webp';
import virtualELogo from '../assets/img/brand/virtual-e.png';
import thingsupLogo from '../assets/img/brand/thingsup.png';
import grassrootLogo from '../assets/img/brand/grassroot.svg';

export const Partners = [
    {
        logo: findingpiLogo,
        name: "FindingPi",
        url: "https://www.findingpi.com/"
    }, 
    {
        logo: w3villaLogo,
        name: "w3villa",
        url: "https://www.w3villa.com/"
    },
    {
        logo: virtualELogo,
        name: "virtual-e",
        url: "https://in.linkedin.com/company/virtual-e-in"
    },
    {
        logo: thingsupLogo,
        name: "ThingsUp",
        url: "https://thingsup.io/"
    },
    {
        logo: grassrootLogo,
        name: "Grassroot",
        url: "http://www.grassrootdesign.com/"
    },
]